<template>
  <ImageListShow :image-list="imgList" />
</template>

<script>
import ImageListShow from '~/components/Base/ImageListShow'

export default {
  components: {
    ImageListShow
  },
  props: {
    imgList: {
      type: Array,
      default: () => []
    }
  }
}
</script>
